export default "__VITE_ASSET__BdiSHQPG__"